import React from 'react';
import type { PopperProps } from '@mui/material/Popper';
import MuiPopper from '@mui/material/Popper';

export const Popper: React.FC<PopperProps> = (props) => <MuiPopper { ...props } />;
